import { render, staticRenderFns } from "./EmbeddedTable.vue?vue&type=template&id=20ab1d1d"
import script from "./EmbeddedTable.vue?vue&type=script&lang=js"
export * from "./EmbeddedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports